export const FETCH_DATA_FROM_CRITEO = 'FETCH_DATA_FROM_CRITEO';
export const GET_CRITEO_PRODUCTS_ERROR = 'GET_CRITEO_PRODUCTS_ERROR';
export const GET_CRITEO_PRODUCTS_SUCCESS = 'GET_CRITEO_PRODUCTS_SUCCESS';
export const MERGE_SPONSORED_AND_ORGANIC_PRODUCTS = 'MERGE_SPONSORED_AND_ORGANIC_PRODUCTS';
export const TRIGGER_CRITEO_BEACON = 'TRIGGER_CRITEO_BEACON';
